export default function areEqualValues(value1: any, value2: any): boolean {
  if (typeof value2 === 'object' && value2 !== null) {
    return value1 === value2;
  }

  // The value could be a number, the DOM will stringify it anyway.
  return String(value1) === String(value2);
}
